import _ from 'lodash';
import ChildView from '~/lib/types/ChildView';
import {IdentifiableItemWithImg} from '~/lib/types/IdentifiableItemWithImg';
import {WithNuxtLink} from '~/lib/types/WithNuxtLink';

type _Link = {
  name: 'sklep-shopId-przejdz',
  params: { shopId: string, [key: string]: string },
  query: ShopUrlQuery
} | {
  name: string,
  query: {mode: 'choose_and_redirect_to_shop', forwardToShopId: string}
}

export type ShopView = Omit<Shop, 'redirect_url'> & {
  redirectNuxtLink: _Link
};

export interface ShopUrlQuery {
  ref: Ref
  // @ts-ignore
  userId?: string
  childId: string
  [key: string]: string
}

export type Ref = 'www'

export function toShopView(shop: Shop, child: ChildView | undefined, ref: Ref): ShopView {
  const link = getShopRedirectLink(child, ref, shop);

  return {
    redirectNuxtLink: link,
    ..._.omit(shop, 'redirect_url')
  };
}


export function getShopRedirectLink(child: ChildView | Child | undefined, ref: Ref, shop: Shop): ShopView['redirectNuxtLink'] {
  if (child) {
    const query: ShopUrlQuery = {
      ref: ref,
      childId: child.id + '',
      ...(shop.userId && { userId: shop.userId })
    };
    return {
      name: 'sklep-shopId-przejdz',
      params: {
        shopId: shop.id + ''
      },
      query
    };
  }

  // If child is undefined then we need to choose a child before redirecting to the shop.
  else {
    return {
      name: 'podopieczni',
      query: { mode: 'choose_and_redirect_to_shop', forwardToShopId: shop.id + '' },
    };
  }
}

export function toShopLogo(shop: Shop, nuxtLink: WithNuxtLink["nuxtLink"]): IdentifiableItemWithImg {
  return {
    id: shop.id,
    imgSrc: shop.logo_thumb_mobile,
    imgAlt: 'Logo sklepu '+shop.name,
    nuxtLink: nuxtLink
  }
}
